import { Menu } from 'semantic-ui-react';
import { useNavigate, useLocation } from 'react-router-dom';

const option = [
  {
    id: 2,
    categoryName: '用户统计',
    link: '/',
    search: '',
  },
  {
    id: 9,
    categoryName: '用户管理',
    link: 'userManage',
    search: '',
  },
  {
    id: 1,
    categoryName: '公告管理',
    link: 'announcement',
    search: 'form=admin'
  },
  {
    id: 8,
    categoryName: '付款管理',
    link: 'payment',
    search: '',
  },
  {
    id: 3,
    categoryName: '推广管理',
    link: 'promotion',
    search: '',
  },
  {
    id: 4,
    categoryName: '推广统计',
    link: 'promotionStatistics',
    search: '',
  },
  {
    id: 7,
    categoryName: '推广明细',
    link: 'promotionDetails',
    search: '',
  },
  {
    id: 5,
    categoryName: '结算管理',
    link: 'settlementManage',
    search: '',
  },
  {
    id: 6,
    categoryName: '结算明细',
    link: 'settlementDetails',
    search: '',
  },
  {
    id: 10,
    categoryName: '支持账号',
    link: 'support',
    search: '',
  },
  {
    id: 11,
    categoryName: '开放功能',
    link: 'function',
    search: '',
  },
];

const Nav = () => {
  const navigate = useNavigate();
  const { pathname } = useLocation();
  return (
    <Menu pointing secondary vertical>
      {option.map((item) => (
        <Menu.Item
          key={item.id}
          name={item.categoryName}
          active={pathname === `/${item.link}` || (item.link === '/' && pathname === '/')}
          onClick={() => {
            navigate(item.link.startsWith('/') ? item.link : `/${item.link}?${item.search}`);
          }}
        />
      ))}
    </Menu>
  );
};

export default Nav;
